$(function() {

  $('.sub-div').find('.content').find('select, input').on('focus', function() {
    $(this).removeClass('bad-form-field');
  });

  $('#terms-of-service').removeAttr('checked');

  $("#cartform").on('submit', function(){
    if (sentinel.updating_quantity) {
    // skip validating for updating quantity
      sentinel.updating_quantity = false;
      return true;
      }
    $.event.trigger('terms-tooltip', [sentinel.terms]);
    $.event.trigger('shipping-tooltip', [sentinel.shipping]);
    var val =  sentinel.validate();
    return val;
  });

  $('#country').on('change', function() { sentinel.shipping = ''; sentinel.shipping_selected = '';});

  $('.shipping-category-block div.shipping-rates-div').on('click', function() {
    sentinel.shipping_selected = $(this).attr('id');    
  });

  $('#terms-of-service').on('click', function() {
    sentinel.terms = $(this).is(':checked');
  });
});
